// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falW: CreateIconOptions = {
  "displayName": "FALW",
  "viewBox": "0, 0, 576, 512",
  "d": "M10.5 33c8.3-3 17.5 1.2 20.5 9.5l135.2 370L272.6 43.6c2-6.8 8.2-11.6 15.4-11.6s13.4 4.7 15.4 11.6L409.8 412.5 545 42.5c3-8.3 12.2-12.6 20.5-9.5s12.6 12.2 9.5 20.5l-152 416c-2.4 6.5-8.7 10.7-15.6 10.5s-12.9-4.9-14.8-11.6L288 105.7 183.4 468.4c-1.9 6.6-7.9 11.3-14.8 11.6s-13.2-4-15.6-10.5L1 53.5C-2.1 45.2 2.2 36 10.5 33z"
};
